/**
 * Долгий тап (A5, A8): удержание LONG_PRESS_MS вызывает `onLong`, обычный
 * клик — `onTap`. Клик, который завершает долгое удержание, глотается,
 * чтобы одно касание не сработало дважды. Один хук обслуживает много
 * элементов (карту из 80 клеток, строки журнала): нажатие бывает только
 * одно за раз, поэтому таймер общий.
 */
import { useEffect, useRef } from 'preact/hooks';
import type { JSX } from 'preact';

export const LONG_PRESS_MS = 500;

export interface PressHandlers {
  onPointerDown: JSX.PointerEventHandler<HTMLElement>;
  onPointerUp: JSX.PointerEventHandler<HTMLElement>;
  onPointerLeave: JSX.PointerEventHandler<HTMLElement>;
  onPointerCancel: JSX.PointerEventHandler<HTMLElement>;
  onContextMenu: JSX.MouseEventHandler<HTMLElement>;
  onClick: JSX.MouseEventHandler<HTMLElement>;
}

export function useLongPress(): (onLong: () => void, onTap?: () => void) => PressHandlers {
  const state = useRef<{ timer: ReturnType<typeof setTimeout> | null; fired: boolean }>({ timer: null, fired: false });

  const cancel = () => {
    if (state.current.timer !== null) {
      clearTimeout(state.current.timer);
      state.current.timer = null;
    }
  };

  useEffect(() => cancel, []);

  return (onLong, onTap) => ({
    onPointerDown: (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      cancel();
      state.current.fired = false;
      state.current.timer = setTimeout(() => {
        state.current.timer = null;
        state.current.fired = true;
        onLong();
      }, LONG_PRESS_MS);
    },
    onPointerUp: cancel,
    onPointerLeave: cancel,
    onPointerCancel: cancel,
    onContextMenu: (e) => e.preventDefault(),
    onClick: (e) => {
      if (state.current.fired) {
        state.current.fired = false;
        e.preventDefault();
        return;
      }
      onTap?.();
    },
  });
}
